export const settingsKeys = {
  all: ['settings'] as const,
  global: ['settings', 'global'] as const,
  instrumentMappings: (counterparty: string) =>
    ['settings', 'instrument-mappings', counterparty] as const,
} as const;

